import api from '../../services/apiConfig';

export interface RastreioPedido {
    id: number;
    pedidoComercial: number;
    operacao: number;
    pedidoProducao: string;
    dataNota: string;
    numeroNota: string;
    cliente: string;
    prazoPrevisto: number | null;
    transportadora: string;
    ufEntrega: string;
    cidadeEntrega: string;
    codigoRastreio: string | null;
    previsaoEntrega: string | null;
    dataEntrega: string | null;
    dataEntregaAgendada: string | null;
    dataConferencia: string | null;
    dataCarregamentoReal: string | null;
    obsEntrega: string;
    obs: string | null;
    status: string;
    statusText: string;
}

export interface RastreioEstatisticas {
    total: number;
    entregues: number;
    dentroDoPrazo: number;
    emSeparacao: number;
    emViagem: number;
    atrasados: number;
    atrasoCarregamento: number;
    indisponivel: number;
}

export const fetchRastreioPedidos = async (
    startDate: string,
    endDate: string,
    page: number = 1,
    limit: number = 30,
    search?: string,
    status?: string,
    transportadora?: string,
    ufEntrega?: string,
    sortBy?: string,
    sortOrder?: 'asc' | 'desc'
) => {
    try {
        const response = await api.get(`/rastreio/pedidos`, {
            params: {
                startDate,
                endDate,
                page,
                limit,
                search,
                status,
                transportadora,
                ufEntrega,
                sortBy,
                sortOrder
            }
        });
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar pedidos de rastreio:', error);
        throw error;
    }
};

export const fetchRastreioEstatisticas = async (
    startDate: string,
    endDate: string,
    transportadora?: string
) => {
    try {
        const response = await api.get<RastreioEstatisticas>(`/rastreio/estatisticas`, {
            params: { startDate, endDate, transportadora }
        });
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar estatísticas de rastreio:', error);
        throw error;
    }
};

export const fetchTransportadoras = async (
    startDate: string,
    endDate: string
) => {
    try {
        const response = await api.get<string[]>(`/rastreio/transportadoras`, {
            params: { startDate, endDate }
        });
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar transportadoras:', error);
        throw error;
    }
};
